import { action, observable, makeObservable } from "mobx";
import { api } from "../lib/api";
import { ICreateContactMessageRequest } from "../models/apiRequests";
import { SharedStateStore } from "./SharedStateStore";

export interface IContactPageMessage {
  name: string;
  email: string;
  contactType: string;
  subject: string;
  message: string;
}

export class ContactPageStore extends SharedStateStore {
  sent = false;

  sending = false;

  error: boolean = false;

  message: IContactPageMessage = {
    name: "",
    email: "",
    contactType: "",
    subject: "",
    message: ""
  };

  constructor() {

    super()

    makeObservable(this, {
      sent: observable,
      sending: observable,
      error: observable,
      message: observable,
      sendMessage: action
    });
  }

  async sendMessage() {
    this.setState({
      sending: true,
      error: false
    })

    try {
      await api.create<void, ICreateContactMessageRequest>("contact", {
        ...this.message
      });
      this.setState({ sent: true })
    } catch (err) {
      this.setState({ error: true })
    } finally {
      this.setState({ sending: false })
    }
  }
}
